<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" @click="overlay = false"></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size:30px" class="mb-0">Locaciones</p>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="registro=true">Registro</v-btn>
          <v-btn @click="registro=false">Admin</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="7" xl="7" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <v-autocomplete
                v-model="idlocacion"
                :items="locaciones"
                :search-input.sync="searchlocacion"
                flat
                hide-no-data
                hide-details
                label="Buscar locacion..."
                solo-inverted
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="1" xl="1"></v-col>
            <!-- Informacion personal -->
            <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" class="pt-5" dense>
              <span class="font-weight-bold primary--text">Datos generales</span>
              <v-row dense>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6">
                  <v-row dense>
                     <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-autocomplete
                        v-model="idubigeo"
                        :items="ubigeos"
                        label="Ubigeos"
                        class="pt-0"
                        dense
                        :rules="[() => !!idubigeo || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="idubigeo"
                        required
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-4">
                      <v-text-field
                        v-model="locacion"
                        label="Locación"
                        dense
                        class="pt-0"
                        :rules="[() => !!locacion || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="locacion"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-divider class="mx-4" vertical></v-divider>
                <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-select
                        :items="tipo_locacions"
                        v-model="tipo_locacion"
                        dense
                        class="pt-0"
                        label="Tipo"
                        :rules="[() => !!tipo_locacion || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="tipo_locacion"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-autocomplete
                        v-model="clasificacion_locacion"
                        :items="clasificaciones_locacion"
                        label="Clasificacion"
                        class="pt-0"
                        dense
                        chips
                        multiple
                        @input="searchInput=null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove(data.item)"
                          >
                            <span>{{ data.item }}</span>
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="primary" class="mb-5" @click="save" :disabled="overlay2">Guardar</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5" dense v-if="registro">
        <v-card class="mx-auto" outlined>
          <v-row dense class="pa-3">
            <!-- Area-->
            <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
              <v-row dense>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
                  <span class="font-weight-bold primary--text">Observaciones</span>
                </v-col>
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-textarea
                        v-model="observaciones"
                        :rows="2"
                        class="pt-0"
                        dense
                      ></v-textarea>
                  </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense v-else>
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="locacion_headers"
                :items="locacion_item"
                :search="searchlocacions"
                sort-by="locacion"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2">Locaciones</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="adModal" max-width="290px">
                      <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">
                          <span class=".font-weight-thin">¿Activar item?</span>
                        </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">
                          <span class=".font-weight-thin">¿Desactivar item?</span>
                        </v-card-title>
                        <v-card-text>
                          Estas a punto de
                          <span v-if="adAccion==1">activar</span>
                          <span v-if="adAccion==2">desactivar</span>
                          el item asoaciado a
                          <strong>{{adNombre}}</strong>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            outlined
                            @click="ActivarDesactivarCerrar()"
                          >Cancelar</v-btn>
                          <v-btn
                            v-if="adAccion==1"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Activar()"
                          >Activar</v-btn>
                          <v-btn
                            v-if="adAccion==2"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Desactivar()"
                          >Desactivar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchlocacions"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <!-- Template para condicion -->
                <template v-slot:item.condicion="{ item }">
                  <v-switch v-model="item.condicion" inset @change="ActivarDesactivar(item)"></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemLocacion(item)"
                  >mdi-square-edit-outline</v-icon>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{icon}}</v-icon>
        {{error}}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  data() {
    return {
      //Ayuda
      registro: true,
      nuevo: true,
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      overlay: false,
      overlay2: false,
      snackbar: false,
      error: null,
      errorMessages: "",
      form1HasErrors: false,
      form2HasErrors: false,
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      dialogclasificacion: false,
      searchInput: null,
      //Tablas
      locacion_headers: [
        { text: "Ubigeo", value: "ubigeo"},
        { text: "Tipo",  value: "tipo_locacion"},
        { text: "Locacion", value: "locacion"},
        { text: "Clasificacion", value:"clasificacion"},
      ],
      locacion_item: [],
      
      /*Locacion */
      tipo_locacions: [
        { text: "Anexo", value: "ANEXO" },
        { text: "Barrio", value: "BARRIO" },
        { text: "Centro poblado", value: "CENTRO POBLADO" },
        { text: "Comunidad campesina", value: "COMUNIDAD CAMPESINA" },
      ],
      clasificacion_locacion:[],
      clasificaciones_locacion:["AISD", "AISI","VECINO"],
      observaciones:"",
      searchlocacion: "",
      searchlocacions: "",
      editedIndex: -1,
      idlocacion: "",
      locacion: "",
      abreviatura: "",
      tipo_locacion: "",
      idubigeo: "",
      locaciones: [],
      ubigeos: [],
    
     /*Soporte*/
      valida: 0,
      validamensaje: [],
    };
  },
  created() {
    this.listar();
    this.selectLocacion();
    this.selectUbigeos();
    let me = this;
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },

  computed: {
    form1() {
      return {
        idubigeo: this. idubigeo,
        locacion: this.locacion,
        tipo_locacion: this.tipo_locacion,
       };
    },
    form2() {
      return {
        clasificador: this.clasificador,
        clasificacion: this.clasificacion,
      };
    },
  },
  methods: {
    remove(item) {
      const index = this.clasificacion_locacion.indexOf(item);
      if (index >= 0) this.clasificacion_locacion.splice(index, 1);
    },
    /*Empresa*/
    ActivarDesactivar(item) {
      //La adAccion 1 = Activar y 2 = Desactivar
      this.adModal = 1;
      this.adNombre = item.locacion;
      this.adId = item.idlocacion;
      if (item.condicion) {
        this.adAccion = 1;
      } else {
        this.adAccion = 2;
      }
    },
    ActivarDesactivarCerrar() {
      this.adModal = 0;
      this.listar();
      this.selectLocacion();
    },
    Activar() {
      let me = this;
      axios
        .put("/api/Locaciones/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectLocacion();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    Desactivar() {
      let me = this;
      axios
        .put("/api/Locaciones/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectLocacion();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;
        this.$refs[f].validate(true);
      });
    },

    editItemLocacion(item) {
      this.overlay = true;
      this.idlocacion = item.idlocacion;
      this.registro = true;
      this.editItem();
      this.overlay = false;
    },
    /* Tabla */
    listar() {
      let me = this;
      axios
        .get("api/Locaciones/Listar")
        .then(function (response) {
          me.locacion_item = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    selectLocacion() {
      let me = this;
      var Array = [];
      me.locaciones = [];
      axios
        .get("api/Locaciones/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.locaciones.push({ text: x.locacion, value: x.idlocacion });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },

    selectUbigeos() {
      let me = this;
      var Array = [];
      me.ubigeos = [];
      axios
        .get("api/Ubigeos/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.ubigeos.push({ text: x.consolidado, value: x.idubigeo });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },

    editItem() {
      this.overlay = true;
      let me = this;
      var Array = [];
      axios
        .get("api/Locaciones/Mostrar/" + me.idlocacion)
        .then(function (response) {
          console.log(response.data.idlocacion);
          me.idlocacion = response.data.idlocacion;
          me.idubigeo = response.data.idubigeo;
          me.locacion = response.data.locacion;
          me.tipo_locacion = response.data.tipo_locacion;
          me.observaciones = response.data.observaciones;
          me.clasificacion_locacion = response.data.clasificacion.split(',');
          me.editedIndex = 1;
          me.nuevo = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.overlay = false;
    },
    editItemLocacion(item) {
      this.idlocacion = item.idlocacion;
      this.idubigeo = item.idubigeo;
      this.locacion = item.locacion;
      this.observaciones = item.observaciones;
      this.tipo_locacion = item.tipo_locacion;
      this.clasificacion_locacion = item.clasificacion.split(',');
      this.editedIndex = 1;
    },

    limpiar() {
      this.idlocacion = "";
      this.idubigeo = "";
      this.locacion = "";
      this.observaciones = "";
      this.clasificacion_locacion = [];
      this.editedIndex = -1;
      this.limpiarAreaTotal();
      this.nuevo = true;
    },
    save() {
      this.validar1();
      if (this.form1HasErrors == false) {
        if (this.editedIndex > -1) {
          let me = this;
          axios
            .put("/api/Locaciones/Actualizar", {
              idlocacion: me.idlocacion,
              locacion: me.locacion.toUpperCase(),
              tipo_locacion: me.tipo_locacion,
              observaciones: me.observaciones,
              //OJO Aqui lo seapramos por coma y crearmos una REGEX par que en caso la primera letra sea coma la elimine.
              clasificacion: me.clasificacion_locacion.join().replace(/^,/, ''),
              latitud:0,
              longitud:0,
              idubigeo: me.idubigeo,
            })
            .then(function (response) {
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.selectLocacion();
              me.listar();
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        } else {
          let me = this;
          axios
            .post("/api/Locaciones/Crear", {
              locacion: me.locacion.toUpperCase(),
              abreviatura: me.abreviatura.toUpperCase(),
              tipo_locacion: me.tipo_locacion,
              observaciones: me.observaciones,
              clasificacion: me.clasificacion_locacion.join(","),
              latitud:0,
              longitud:0,
              idubigeo: me.idubigeo,
            })
            .then(function (response) {
              me.idlocacion = Number(response.data);
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
              me.editedIndex = 1;
              me.selectLocacion();
              me.listar();
              me.nuevo = false;
            })
            .catch(function (error) {
              console.log(error.response);
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
              me.overlay2 = false;
            });
        }
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
  },
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
</style>